import jQuery from 'jquery';

import 'materialize-css/js/velocity.min';
import 'materialize-css/js/hammer.min';
import 'materialize-css/js/jquery.hammer';
import 'materialize-css/js/global';
import 'materialize-css/js/sideNav';
import 'materialize-css/js/collapsible';
import 'materialize-css/js/jquery.easing.1.4';

import '../../styles/frontend/materialize.scss';
import '../../styles/frontend/navigation.scss';
import '../../styles/frontend/general.scss';
import '../../styles/frontend/index.scss';
import '../../styles/frontend/home.scss';

export default function init() {
    jQuery('.button-collapse').sideNav();
}



// WEBPACK FOOTER //
// ./scripts/utils/ui.js